import useLoader from './useLoader';

export default useLoader;
